import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
    selector: `[min-max-input]`
})
/**
 * HOW TO USE :
 * 1. use minmax directive to set min and max value in input field.
 * 2. send input control name in formControl key.
 * 3. send min value in minValue key and max value in maxValue key(optional).
 * if value comes null , it will auto set min value 
 */
export class MinMaxDirective implements AfterViewInit {
    @Input('min-max-input') data: any;
    constructor(private elRef: ElementRef) {
    }
    ngAfterViewInit(): void {
        this.data.formControl.valueChanges
            .debounceTime(200)
            .subscribe(value => {
                if (this.data.minValue >= 0) {
                    if (value == null || value == 0 || (value && value < this.data.minValue)) {
                        this.data.formControl.setValue(this.data.minValue);
                    }
                }
                if (this.data.maxValue) {
                    if (value && value > this.data.maxValue) {
                        this.data.formControl.setValue(this.data.maxValue);
                    }
                }

            });

    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/min-max.directive.ts